import {Tooltip} from "react-tooltip";
import React, {CSSProperties} from "react";
import './HelpTooltip.css'

type Props = {
  text: string,
  tooltipStyle?: CSSProperties,
  tooltipClasses?: string,
}

export const HelpTooltip = (props: Props) => {

  return <div>
    <a className={'HelpTooltip ' + props.tooltipClasses}
       style={props.tooltipStyle}
       data-tooltip-id="help-tooltip"
       data-tooltip-content={props.text}
       data-tooltip-place="top">?</a>
    <Tooltip 
        style={{maxWidth: 300}}
        id="help-tooltip"/>
  </div>
}